var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1943085525840"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#1969EE",
    cx: 1250,
    cy: 1250,
    r: 1250
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1168.5,330.5c45.7-24,115.3-24,161,0l466.6,244.4c27.5,14.4,42.7,35.9,45.4,58.1h0.4v1228.3    c-0.6,24.2-15.9,48.2-45.8,63.9l-466.6,244.4c-45.7,24-115.3,24-161,0L702,1925.2c-29.8-15.6-44.1-39.8-44.8-63.9    c-0.1-2.4-0.1-4.4,0-6V640.8c0-1.3,0-2.7,0-4l0-3.9h0.2c2.1-22.4,16.5-43.4,44.6-58.1L1168.5,330.5L1168.5,330.5z M1768.4,1318.2    l-438.9,229.9c-45.7,23.9-115.3,23.9-161,0l-438-229.4v540.1l438,228.2c24.7,13.1,50.4,25.9,75.5,27.5l5,0.2    c26.1,0.1,51.5-13.1,77.3-25.6l442.1-232.3V1318.2z M581.2,1834.5c0,47.1,5.5,78,16.5,99.8c9.1,18.1,22.7,31.9,47.5,48.7l1.4,0.9    c5.5,3.7,11.5,7.5,18.8,12l8.6,5.2l26.5,15.9l-38,62.3l-29.7-17.8l-5-3c-8.6-5.3-15.7-9.8-22.3-14.2    c-70.9-47.4-97.3-99-97.8-206.5l0-3.3L581.2,1834.5L581.2,1834.5z M1212.3,989c-3.4,1.2-6.6,2.5-9.5,4l-466.5,244.4    c-0.5,0.2-1,0.5-1.4,0.8l-0.4,0.2l0.7,0.4l1.1,0.6l466.6,244.4c2.9,1.5,6.1,2.9,9.5,4V989L1212.3,989z M1285.7,989v498.7    c3.4-1.2,6.6-2.5,9.5-4l466.6-244.4c0.5-0.3,0.9-0.5,1.4-0.8l0.4-0.2l-0.7-0.4l-1.1-0.6L1295.2,993    C1292.3,991.5,1289.1,990.1,1285.7,989L1285.7,989z M1768.4,720.1l-418.5,219.2l418.5,219.2V720.1z M730.6,720.6V1158l417.5-218.7    L730.6,720.6z M1295.2,394.8c-24.3-12.7-68.2-12.7-92.4,0L736.3,639.2c-0.5,0.2-1,0.5-1.4,0.8l-0.4,0.2l0.7,0.4l1.1,0.6    l466.5,244.4c24.3,12.7,68.2,12.7,92.4,0l466.5-244.4c0.5-0.2,0.9-0.5,1.4-0.8l0.4-0.2l-0.7-0.4l-1.1-0.6L1295.2,394.8    L1295.2,394.8z M1837.4,421.6l29.7,17.8l5,3c8.6,5.3,15.7,9.8,22.3,14.2c70.9,47.4,97.3,99,97.8,206.5l0,3.3h-73.4    c0-47.1-5.5-78-16.5-99.8c-9.1-18.1-22.7-31.9-47.6-48.7l-1.4-1c-5.5-3.7-11.5-7.5-18.8-12l-8.6-5.2l-26.5-15.9L1837.4,421.6    L1837.4,421.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantom);
export default __webpack_public_path__ + "static/media/fantom.1a782d33fb35bdec75f85cbb54f920a4.svg";
export { ForwardRef as ReactComponent };